// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1pMv3","name":"ConsentHeader_name__2O7Nf","birthday":"ConsentHeader_birthday__3LzVR","skeleton":"ConsentHeader_skeleton__18ctY"};